export const styles = {
	StackContainer: {
		minHeight: '100%',
		height: '100%',
	},
	ContentBox: {
		flexGrow: 1,
		pt: 4,
		px: 4,
	},
	list: {
		width: '100%',
	},
	SearchRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '1rem',
	},
	searchBarStyle: {
		'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: '#45657B',
		},
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: '#45657B',
		},
		'.MuiOutlinedInput-notchedOutline': {
			borderColor: '#45657B',
		},
		backgroundColor: '#FFFFFF',
		borderRadius: '4px',
		height: '4rem',
		minWidth: '40%',
	},
	dataGridWrapper: {
		mt: 3,
	},
	dataGrid: {
		backgroundColor: '#FFFFFF',
		fontSize: 14,
		'& .MuiDataGrid-columnHeaders': { backgroundColor: '#F5F5F5' },
		'& .MuiDataGrid-columnHeaderTitle': { color: 'rgba(0, 0, 0, 0.87)' },
		'& .MuiDataGrid-cell': {
			alignItems: 'center',
			color: 'rgba(0, 0, 0, 0.87)',
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor: '#F5F5F5 !important',
		},
		'& .MuiDataGrid-row.Mui-selected': {
			backgroundColor: '#F5F5F5 !important',
		},
		'& .MuiDataGrid-row.Mui-selected:hover': {
			backgroundColor: '#F5F5F5 !important',
		},
		'& .MuiDataGrid-row.Mui-hovered': {
			backgroundColor: '#F5F5F5 !important',
		},
		'& .MuiCheckbox-root': { color: 'rgba(0, 0, 0, 0.87)' },
		'& .MuiTablePagination-selectIcon': { color: 'rgba(0, 0, 0, 0.87)' },
		'& .MuiIconButton-root': { color: 'rgba(0, 0, 0, 0.87)' },
		'& .MuiTablePagination-selectLabel': {
			fontSize: 12,
			color: 'rgba(0, 0, 0, 0.6)',
		},
		'& .MuiTablePagination-displayedRows': {
			fontSize: 12,
			color: 'rgba(0, 0, 0, 0.87)',
		},
		'& .MuiTablePagination-select': {
			fontSize: 12,
			color: 'rgba(0, 0, 0, 0.87)',
		},
	},
	emailLink: {
		color: 'rgba(69, 101, 123, 1)',
		textDecoration: 'underline',
		fontSize: 16,
	},
	actionsCell: {
		display: 'flex',
		gap: 0.5,
	},
	actionsCellIcon: {
		color: 'rgba(39, 74, 98, 1)',
	},
	statusChipAccountCreated: {
		color: '#2E7D32',
		borderColor: '#2E7D32',
	},
	statusChipAccountCreatedIcon: {
		fontSize: 16,
		color: '#2E7D32 !important',
	},
	statusChipSetupPending: {
		color: '#FF9800',
		borderColor: '#FF9800',
	},
	statusChipSetupPendingIcon: {
		fontSize: 16,
		color: '#FF9800 !important',
	},
	statusChipInviteExpired: {
		color: '#D32F2F',
		borderColor: '#D32F2F',
	},
	statusChipInviteExpiredIcon: {
		fontSize: 16,
		color: '#D32F2F !important',
	},
	editTextField: {
		'& .MuiInputBase-input': {
			fontSize: 14,
			padding: '2px 4px',
		},
		width: '100%',
	},
	licensesCell: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		width: '100%',
	},
	licensesEditField: {
		'& .MuiInputBase-input': {
			fontSize: 14,
			padding: '2px 4px',
			width: '40px',
		},
	},
	editSelect: {
		fontSize: 14,
		width: '100%',
		'& .MuiSelect-select': {
			padding: '4px 8px',
		},
	},
	editSelectMenuItem: {
		fontSize: 14,
	},
	cancelSaveCell: {
		display: 'flex',
		gap: '8px',
		alignItems: 'center',
	},
	addNewUsersButton: {
		whiteSpace: 'nowrap',
	},
}
